export default {
  strict: true,
  namespaced: true,
  state: {
    list: [],
    searchInput: '',
    maxList: 0,
    currentPage: 1,
    perPage: 20,
    orderAsc: 1,
    isLoading: false,
    enable: true,
    searchContainer: true
  },
  mutations: {
    resetSearchGlobalList(state) { state.list = [] },
    resetSearchGlobalInput(state) { state.searchInput = '' },
    setSearchGlobalInput(state, value) { state.searchInput = value },
    addSearchGlobalList(state, value) { state.list.push(value) },
    setSearchGlobalIsLoading(state, value) { state.isLoading = value },
    setSearchGlobalCurrentPage(state, value) { state.currentPage = value },
    setSearchGlobalMaxList(state, value) { state.maxList = value },
    setSearchGlobalEnable(state, value) { state.enable = value },
    setSearchGlobalContainer(state, value) { state.searchContainer = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/search-global/index.js